import {
  Box,
  Center,
  PinInput,
  PinInputField,
  FormControl,
  FormLabel,
  Input,
  HStack,
  Stack,
  Button,
  Text,
  useColorModeValue,
  Link as ChakraLink,
  NumberInput,
  NumberInputField,
  useToast,
  Checkbox,
  Divider,
 } from "@chakra-ui/react";
 import { useState, Dispatch, SetStateAction, useEffect } from "react";
 import { useRouter } from "next/router";
 import useSignup from "../../lib/hooks/QueryHooks/useSignup";
 import {
  useRequestOTP,
  useVerifyOTP,
 } from "../../lib/hooks/QueryHooks/useLogin";
 import useAuthStore from "@/lib/store/useAuthStore";
 import useZustandStore from "@/lib/store/useZustandStore";
 import axios, { AxiosError } from "axios";
 import { logEvent } from "@/analytics";
 import Link from "next/link";
 import { FcGoogle } from "react-icons/fc";
 import { useGoogleLogin } from "@react-oauth/google";
 import useGoogleAuth from "@/lib/hooks/QueryHooks/useGoogleAuth";
 import { countryCode } from "@/lib/countryCodes";
 import useLoginWithOTPLess from "@/lib/hooks/useLoginWithOTPLess";
 import useCheckLogin from "@/lib/hooks/useCheckLogin";
 import debounce from 'lodash/debounce';
 const SignupCheck = () => {
  const { mutate: signUpMutate } = useSignup();
  // const { data: isLoggedIn } = useCheckLogin();
  const [tncChecked, setTncChecked] = useState(false);
  const { mutate: requestOTPMutate } = useRequestOTP();
  const [verifyState, setVerifyState] = useState("");
  const { mutate: verifyOTPMutate } = useVerifyOTP();
  const { mutate: googleAuthMutate } = useGoogleAuth();
  const { mutate: loginWithOTPLessMutate } = useLoginWithOTPLess();
  const { setUserData, setToken, otplessUserData, isItOtpless } = useAuthStore(
    (state) => state
  );
  const setUser = useZustandStore((state) => state.setUser);
  const [isLoading, setIsLoading] = useState(false);
 
 
  const [signupInfo, setSignupInfo] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    otp: "",
    referralCode: "",
  });
  const toast = useToast();
  const navigation = useRouter();
  const { referral_code } = navigation.query;
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [countryCodeSearchInput, setCountryCodeSearchInput] = useState(``);
  const [countryCodeModalState, setCountryCodeModalState] = useState(false);
  const [modalBgState, setModalBgState] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState({
    name: "India",
    region: "Asia",
    timezones: {
      "Asia/Kolkata": "+05:30",
    },
    iso: {
      "alpha-2": "IN",
      "alpha-3": "IND",
      numeric: "356",
    },
    phone: ["+91"],
    emoji: "🇮🇳",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IN.svg",
    phoneLength: 10,
  });

  const debouncedSetState = debounce((updateState) => {
    setSignupInfo((prevState) => ({
      ...prevState,
      ...updateState,
    }));
  }, 1500);

  const handleInputChange = (field, value) => {
    debouncedSetState({ [field]: value });
  };
 
  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);
  }, []);
 
 
  const hasReferralCode = typeof referral_code === "string";
  if (isLoggedIn) {
    navigation.push("/");
  }
  const handleLoginProcess = async (res: any) => {
    if (res.data.full_name) {
      toast({
        title: "Logged In",
        description: "Welcome back, " + res.data.full_name,
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top",
      });
    }
    localStorage.setItem("token", res.data.token);
    setToken(res.data.token);
    localStorage.setItem("user", res.data.full_name);
    let userData;
    try {
      userData = await axios.get(
        `${
          process.env.NEXT_PUBLIC_API_URL
        }/api/method/bonatra.custom.latest_customer_v2?user=${localStorage.getItem(
          "email"
        )}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
    } catch (e) {
      console.log("latest customer v2 error : ", e);
    }
    setUserData(userData?.data?.message);
    setUser(res?.data?.message?.data?.user);
    if (userData) {
      if (navigation.asPath === "/signup") {
        navigation.push("/");
      } else {
        navigation.back();
      }
    }
  };
  const handleGoogleLogin = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      googleAuthMutate(tokenResponse.access_token, {
        onSuccess: async (res: any) => {
          if (res?.data?.message?.signup) {
            googleAuthMutate(tokenResponse.access_token, {
              onSuccess: async (res: any) => {
                handleLoginProcess(res);
                setIsLoading(false);
              },
              onError: () => {
                setIsLoading(false);
                toast({
                  title: "Error",
                  description:
                    "An error occurred while signing in with Google, please try later",
                  status: "error",
                  duration: 2000,
                  isClosable: true,
                  position: "top",
                });
              },
            });
            return;
          }
          handleLoginProcess(res);
          setIsLoading(false);
        },
        onError: (error: any) => {
          setIsLoading(false);
          if (error.response.status == 409) {
            toast({
              title: "Error",
              description: "Please sign up first",
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top",
            });
            return;
          }
          toast({
            title: "Error",
            description:
              "An error occurred while signing in with Google, please try later",
            status: "error",
            duration: 2000,
            isClosable: true,
            position: "top",
          });
        },
      });
    },
  });
 
  const handleSignup = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    let payload = {
      session_id: localStorage.getItem("otp_session_id"),
      otp: signupInfo.otp,
      use_jwt: 1,
      device: "mobile",
    };
    setIsLoading(true);
    verifyOTPMutate(
      { payload: payload },
      {
        onSuccess: async (res) => {
          setIsLoading(false);
          toast({
            title: "Logged In",
            status: "success",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
          localStorage.setItem("token", res?.data?.token);
          setToken(res?.data?.token);
          localStorage.setItem("user", res?.data?.full_name);
          localStorage.setItem("mobile_no", signupInfo?.mobile);
          localStorage.setItem("email", res?.data?.message?.data?.user);
          let userData;
          try {
            userData = await axios.get(
              `${
                process.env.NEXT_PUBLIC_API_URL
              }/api/method/bonatra.custom.latest_customer_v2?user=${localStorage.getItem(
                "email"
              )}`,
              {
                headers: {
                  "Access-Control-Allow-Origin": "*",
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              }
            );
          } catch (e) {
            console.log("latest customer v2 error : ", e);
          }
          setUserData(userData?.data?.message); // api response object
          setUser(res?.data?.message?.data?.user);  // user email
          if (userData) {
            if (navigation.asPath === "/signup") {
              navigation.push("/");
            } else {
              navigation.back();
            }
          }
        },
        onError: (e) => {
          setIsLoading(false);
          toast({
            title: "Invalid OTP",
            status: "error",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        },
      }
    );
  };
 

  const isValidMobileNumber = (mobileNumber: string) => {
    const regex = /^\d{10}$/;
    return regex.test(mobileNumber);
  };

  let loginWithOtplessPayload = {
    token: otplessUserData?.token,
    timestamp: otplessUserData?.timestamp,
    timezone: otplessUserData?.timezone,
    mobile: otplessUserData?.mobile?.number,
    wa_number: otplessUserData?.waNumber,
    wa_name: otplessUserData?.waName,
    device: "mobile",
    use_jwt: 1,
  };

  const signupVerification = async () => {
    if (selectedCountry?.phone[0] !== "+91") {
      toast({
        title: "Login with Google",
        status: "info",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
      navigation.push("/login");
      return;
    }
    if (
      !isItOtpless &&
      selectedCountry?.phone[0] === "+91" &&
      !isValidMobileNumber(signupInfo.mobile)
    ) {
      toast({
        title: "Invalid Mobile Number",
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
      return;
    }
 
    const fullName = signupInfo.firstName + " " + signupInfo.lastName;
 
    const submitInfo = {
      name: isItOtpless ? otplessUserData?.waName : fullName,
      email: signupInfo.email,
      mobile: isItOtpless ? otplessUserData?.waNumber?.substring(2) : signupInfo.mobile,
      referral_code: signupInfo.referralCode,
    };

    setIsLoading(true);
    try {
      if(isItOtpless) {
        signUpMutate(
          { ...submitInfo },
          {
            onSuccess: async (res: { data: { message: string[] } }) => {
              if (res.data.message[1] === "Already Registered") {
                setIsLoading(false);
                toast({
                  title: "Already Registered",
                  status: "info",
                  duration: 3000,
                  isClosable: true,
                  position: "top",
                });
                return;
              } else {
                loginWithOTPLessMutate(
                  { payload: loginWithOtplessPayload },
                  {
                    onSuccess: async (res) => {
                      const TOKEN = res?.data?.token;
                      if (res?.data?.full_name) {
                        toast({
                          title: "Logged In",
                          status: "success",
                          duration: 3000,
                          position: "top",
                          isClosable: true,
                        });
                      }
                      localStorage.setItem("token", TOKEN);
                      localStorage.setItem("user", res?.data?.full_name);
                      localStorage.setItem("email", res?.data?.message?.user);
                      localStorage.setItem(
                        "mobile_no",
                        otplessUserData?.waNumber
                      );
                      let userInfoData;
                      try {
                        userInfoData = await axios.get(
                          `${process.env.NEXT_PUBLIC_API_URL}/api/method/bonatra.custom.latest_customer_v2?user=${res?.data?.message?.user}`,
                          {
                            headers: {
                              Authorization: `Bearer ${TOKEN}`,
                            },
                          }
                        );
                      } catch (e) {
                        console.log("New Customer Error: ", e);
                        toast({
                          title: "New Customer Error",
                          status: "error",
                          duration: 3000,
                          position: "top",
                          isClosable: true,
                        });
                      }
                      setUserData(userInfoData?.data?.message);
                      setUser(res?.data?.message?.data?.user); // user email
                      if (userInfoData) {
                        if (navigation.asPath === "/signup") {
                          navigation.push("/");
                        } else {
                          navigation.back();
                        }
                      }
                    },
                    onError: (error: any) => {
                      console.log("Error from otpless response: ", error);
                      navigation.push("/signup");
                    },
                  }
                )
              }
            },
            onError: (err: any) => {
              console.log("err: ", err);
              setIsLoading(false);
              if (selectedCountry?.phone[0] === "+91") {
                toast({
                  title: err.response.data.exception.split(":")[1],
                  status: "error",
                  duration: 2000,
                  isClosable: true,
                  position: "top",
                });
              }
            },
          }
        );
      } else {
        signUpMutate(
          { ...submitInfo },
          {
            onSuccess: (res: { data: { message: string[] } }) => {
              if (res.data.message[1] === "Already Registered") {
                setIsLoading(false);
                toast({
                  title: "Already Registered",
                  status: "info",
                  duration: 3000,
                  isClosable: true,
                  position: "top",
                });
                return;
              }
                requestOTPMutate(submitInfo.mobile, {
                    onSuccess: (data: any) => {
                      setIsLoading(false);
                      setVerifyState("mobile");
                      toast({
                        title: "OTP sent to your mobile",
                        status: "info",
                        position: "top",
                        duration: 3000,
                        isClosable: true,
                      });
                      localStorage.setItem("otp_session_id", data.data.message);
                    },
                    onError: () => {},
                  });
            },
            onError: (err: any) => {
              console.log("err: ", err);
              setIsLoading(false);
              if (selectedCountry?.phone[0] === "+91") {
                toast({
                  title: err.response.data.exception.split(":")[1],
                  status: "error",
                  duration: 2000,
                  isClosable: true,
                  position: "top",
                });
              }
            },
          }
        );
      }
    }catch(err: any){
      console.log("err: ", err);
      setIsLoading(false);
      if (selectedCountry?.phone[0] === "+91") {
        toast({
          title: err?.response?.data?.exception?.split(":")[1] || "Unknown Error",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top",
        });
      }
    }
  };
 
 
  const handleSelectCountry = (country) => {
    setSelectedCountry(country);
    toggleCountryCodeModal();
  };
 
 
  const countryCodeSearchBar = (
    <input
      className="w-[15%] h-[3.3125rem] rounded-[0.625rem] mt-[15px] border-[2px] border-solid border-[#D9D9D9]"
      type="text"
      title="countryCode"
      defaultValue={selectedCountry.name + " " + `(${selectedCountry.phone})`}
      placeholder="+91"
      onChange={(e) => setCountryCodeSearchInput(e.target.value)}
      value={countryCodeSearchInput}
    ></input>
  );
 
 
  const filteredCountryCodeList = countryCode?.filter(
    (el) =>
      el?.name
        ?.toLocaleLowerCase()
        .includes(countryCodeSearchInput.toLocaleLowerCase())
  );
  const countryCodeList = (
    <div className="absolute z-50 h-96 w-96 overflow-y-scroll shadow-lg bg-white rounded-lg p-4 top-1/2 left-1/2 -translate-x-1/2 -translate">
      {filteredCountryCodeList?.map((country) => {
        const isSelected = selectedCountry.name === country.name;
        return (
          <div
            key={country.name}
            className="p-2 cursor-pointer rounded-lg"
            style={{
              backgroundColor: isSelected ? "#222" : "#fff",
              color: isSelected ? "#FFF" : "#222",
            }}
            onClick={() => handleSelectCountry(country)}
          >
            {country.emoji} {country.name} ({country.phone})
          </div>
        );
      })}
    </div>
  );
 
 
  const countryCodeModal = countryCodeModalState && (
    <div>
      {countryCodeSearchBar}
      {countryCodeList}
    </div>
  );
 
 
  const toggleCountryCodeModal = () => {
    setCountryCodeModalState((p) => !p);
    setModalBgState((p) => !p);
  };
 
 
  const toggleModalBgState = () => {
    setModalBgState((p) => !p);
    setCountryCodeModalState((p) => !p);
  };
 
 
  const modalBg = modalBgState && (
    <div
      className="bg-black h-[500px] w-[300px] md:h-[2000px] md:w-[2000px] opacity-20 top-0 -left-full absolute z-20"
      onClick={
        countryCodeModalState ? toggleCountryCodeModal : toggleModalBgState
      }
    ></div>
  );
 
 
  return (
    <Box rounded={"lg"} bg={useColorModeValue("black", "gray.700")} padding={4}>
      <form onSubmit={handleSignup} id="handle_signup_modal">
        <Stack spacing={4}>
          {!isItOtpless && (
            <HStack>
              <Box>
                <FormControl id="firstName" isRequired>
                  <FormLabel fontSize="xl">First Name</FormLabel>
                  <Input
                    type="text"
                    boxShadow="lg"
                    size="lg"
                    onChange={(event) => handleInputChange('firstName', event.target.value)}
                  />
                </FormControl>
              </Box>
              <Box>
                <FormControl id="lastName">
                  <FormLabel fontSize="xl">Last Name</FormLabel>
                  <Input
                    type="text"
                    boxShadow="lg"
                    size="lg"
                    onChange={(event) => handleInputChange('lastName', event.target.value)}
                  />
                </FormControl>
              </Box>
            </HStack>
          )}
          <FormControl id="email" isRequired>
            <FormLabel fontSize="xl">Email ID</FormLabel>
            <Input
              type="email"
              boxShadow="lg"
              onChange={(event) => handleInputChange('email', event.target.value)}
              size="lg"
            />
          </FormControl>
          {!isItOtpless && (
            <FormControl id="mobile" isRequired>
              <FormLabel fontSize="xl">Mobile</FormLabel>
              <HStack>
                {/* <Input value="+91" isReadOnly={true} size="lg" width="15%" /> */}
                <div
                  className="w-[15%] h-[3.10rem] rounded-[0.625rem] p-2 border-[1px] border-solid border-[#e2e8f0] shadow-lg"
                  onClick={toggleCountryCodeModal}
                >
                  {selectedCountry?.emoji}
                  {selectedCountry?.phone}
                </div>
                <NumberInput size="lg" width="100%">
                  <NumberInputField
                    onChange={(event) => handleInputChange('mobile', event.target.value)}
                    boxShadow="lg"
                  />
                </NumberInput>
              </HStack>
              {countryCodeModal}
              {modalBg}
            </FormControl>
          )}
          {hasReferralCode ? (
            <FormControl id="referralCode">
              <FormLabel fontSize="xl">Referral code</FormLabel>
              <Input
                defaultValue={referral_code}
                isReadOnly={true}
                type="text"
                boxShadow="lg"
                size="lg"
                onChange={(event) => handleInputChange('mobile', event.target.value.toUpperCase())}
              />
            </FormControl>
          ) : (
            <FormControl id="referralCode">
              <FormLabel fontSize="xl">Have a referral code ?</FormLabel>
              <Input
                type="text"
                boxShadow="lg"
                size="lg"
                onChange={(event) => handleInputChange('mobile', event.target.value.toUpperCase())}
              />
            </FormControl>
          )}
          <div className="flex gap-2">
            <Checkbox
              size={"lg"}
              onChange={() => setTncChecked((p) => !p)}
            ></Checkbox>
            <p>
              Agree to all{" "}
              <Link className="text-[#22C55E] cursor-pointer" href="tnc">
                Terms and conditions
              </Link>
            </p>
          </div>
          {tncChecked ? (
            !verifyState ? (
              <Stack spacing={10} pt={2}>
                <Button
                  isLoading={isLoading}
                  id="authentication_sign_up"
                  loadingText="Submitting"
                  size="lg"
                  bg={"#22C55E"}
                  color={"black"}
                  _hover={{
                    bg: "green.700",
                  }}
                  onClick={() => {
                    logEvent("Authentication", "Signup");
                    (window as any).fbq("trackCustom", "Signup");
                    signupVerification();
                  }}
                >
                  Sign up
                </Button>
              </Stack>
            ) : null
          ) : (
            <Stack spacing={10} pt={2}>
              <Button
                //conditionaly rendered this as disabled wasn't working and don't have time to fix
                className="cursor-default"
                // disabled={tncChecked}
                id="authentication_sign_up"
                loadingText="Submitting"
                size="lg"
                bg={"#22C55E"}
                color={"black"}
                _hover={{ bg: "green.700" }}
                _active={{ bg: "#ddd" }}
                _focus={{ bg: "#ddd" }}
              >
                Sign up
              </Button>
            </Stack>
          )}
          <HStack>
            <Divider />
            <Text textStyle="sm" whiteSpace="nowrap" color="fg.muted">
              or
            </Text>
            <Divider />
          </HStack>
          <Button
            w={"full"}
            variant={"outline"}
            _hover={{ bg: "gray.900" }}
            leftIcon={<FcGoogle />}
            size="lg"
            onClick={() => handleGoogleLogin()}
          >
            <Center>
              <Text>Sign in with Google</Text>
            </Center>
          </Button>
          {verifyState ? (
            <MobileVerify setSignupInfo={setSignupInfo} isLoading={isLoading} />
          ) : null}
          <Stack pt={6} mb={10}>
            <Text align={"center"} fontSize="lg">
              Already a user?{" "}
              <ChakraLink
                color={"#22C55E"}
                href="/login"
                fontSize="lg"
                fontWeight="semibold"
              >
                Login
              </ChakraLink>
            </Text>
          </Stack>
        </Stack>
      </form>
    </Box>
  );
 };
 
 
 const MobileVerify = ({
  setSignupInfo,
  isLoading,
 }: {
  setSignupInfo: Dispatch<
    SetStateAction<{
      firstName: string;
      lastName: string;
      email: string;
      mobile: string;
      otp: string;
      referralCode: string;
    }>
  >;
  isLoading: boolean;
 }) => {
  const toast = useToast();
  return (
    <Stack pt={4}>
      <FormControl>
        <Center>
          <HStack>
            <PinInput
              placeholder=""
              onChange={(value) => {
                setSignupInfo((prevState) => ({
                  ...prevState,
                  otp: value,
                }));
              }}
              size="lg"
            >
              <PinInputField />
              <PinInputField />
              <PinInputField />
              <PinInputField />
              <PinInputField />
              <PinInputField />
            </PinInput>
          </HStack>
        </Center>
      </FormControl>
      <Stack pt={4}>
        <Button
          id="authentication_signup_otp"
          isLoading={isLoading}
          loadingText="Verifying..."
          bg={"blue.400"}
          color={"white"}
          _hover={{
            bg: "blue.500",
          }}
          type="submit"
          size="lg"
          onClick={() => {
            logEvent("Authentication", "Verify Signup OTP");
            (window as any).fbq("trackCustom", "Verify Signup OTP");
            toast({
              title: "Check your email to set your password",
              status: "info",
              duration: 3000,
              position: "top",
              isClosable: true,
            });
          }}
        >
          Verify
        </Button>
      </Stack>
    </Stack>
  );
};

export default SignupCheck;
